// features/credential.validation.js

export const getCredentialValidation = (isEditing = false) => ({
  api_key: (value) => {
    if (!isEditing && !value?.trim()) return "API key is required.";
    return "";
  },

  per_day_limit: (value) => {
    if (value === undefined || value === null || value === "") return "Per day limit is required.";
    if (parseInt(value) < 100) return "Per day limit must be at least 100.";
    return "";
  },

  total_mail_limit: (value, formData) => {
    if (value === undefined || value === null || value === "") return "Total mail limit is required.";
    if (parseInt(value) <= 0) return "Total mail limit must be a positive number.";
    const perDay = parseInt(formData?.per_day_limit);
    if (!isNaN(perDay) && parseInt(value) < perDay) {
      return "Total mail limit cannot be less than the per day limit.";
    }
    return "";
  },

  plan_expiry_date: (value) => {
    if (!value) return "";
    const expiry = new Date(value);
    if (isNaN(expiry.getTime())) return "Invalid date.";
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (expiry <= today) return "Plan expiry date must be a future date.";
    return "";
  },

  reminder_days_before: (value) => {
    if (!value) return "";
    const days = parseInt(value);
    if (days < 1 || days > 365) return "Reminder days must be between 1 and 365.";
    return "";
  },
});
